import { ActionItem } from "./types";

export { LANGUAGE_CODES, SECTION_ICONS } from "../shared/constants";
export type { SectionIconEntry } from "../shared/constants";

// ─── Default section titles (multilingual) ─────────────
export const DEFAULT_SECTION_TITLES: Record<string, string> = {
    fr: "Que souhaitez-vous faire ?",
    en: "What would you like to do?",
    ru: "Что вы хотите сделать?",
    it: "Cosa desideri fare?",
    es: "¿Qué desea hacer?",
    pt: "O que deseja fazer?",
    de: "Was möchten Sie tun?",
    ar: "ماذا تريد أن تفعل؟",
};

// ─── Default action buttons ────────────────────────────
export const DEFAULT_ACTIONS: ActionItem[] = [
    {
        id: 1,
        order: 1,
        icon: "restaurant",
        iconColor: "#2E7D32",
        title: {
            fr: "Commander",
            en: "Order",
            ru: "Заказать",
            it: "Ordinare",
            es: "Pedir",
            pt: "Pedir",
            de: "Bestellen",
            ar: "طلب",
        },
        description: {
            fr: "Voir le menu et passer commande",
            en: "View menu and place order",
            ru: "Посмотреть меню и сделать заказ",
            it: "Visualizza il menu e ordina",
            es: "Ver el menú y hacer pedido",
            pt: "Ver o menu e fazer pedido",
            de: "Menü ansehen und bestellen",
            ar: "عرض القائمة وتقديم الطلب",
        },
        titleVisible: true,
        descriptionVisible: true,
        active: true,
    },
    {
        id: 2,
        order: 2,
        icon: "receipt",
        iconColor: "#4CAF50",
        title: {
            fr: "Voir ma commande",
            en: "View my order",
            ru: "Мой заказ",
            it: "Vedi il mio ordine",
            es: "Ver mi pedido",
            pt: "Ver meu pedido",
            de: "Meine Bestellung",
            ar: "عرض طلبي",
        },
        description: {
            fr: "Consulter votre commande en cours",
            en: "Check your current order",
            ru: "Проверить текущий заказ",
            it: "Controlla il tuo ordine in corso",
            es: "Consultar su pedido en curso",
            pt: "Consultar o seu pedido em curso",
            de: "Aktuelle Bestellung prüfen",
            ar: "تحقق من طلبك الحالي",
        },
        titleVisible: true,
        descriptionVisible: true,
        active: true,
    },
    {
        id: 3,
        order: 3,
        icon: "payment",
        iconColor: "#FF9800",
        title: {
            fr: "Payer",
            en: "Pay",
            ru: "Оплатить",
            it: "Pagare",
            es: "Pagar",
            pt: "Pagar",
            de: "Bezahlen",
            ar: "الدفع",
        },
        description: {
            fr: "Régler l'addition",
            en: "Pay the bill",
            ru: "Оплатить счёт",
            it: "Pagare il conto",
            es: "Pagar la cuenta",
            pt: "Pagar a conta",
            de: "Die Rechnung bezahlen",
            ar: "دفع الفاتورة",
        },
        titleVisible: true,
        descriptionVisible: true,
        active: true,
    },
    {
        id: 4,
        order: 4,
        icon: "bell",
        iconColor: "#F44336",
        title: {
            fr: "Appeler serveur",
            en: "Call waiter",
            ru: "Позвать официанта",
            it: "Chiamare cameriere",
            es: "Llamar camarero",
            pt: "Chamar garçom",
            de: "Kellner rufen",
            ar: "استدعاء النادل",
        },
        description: {
            fr: "Service, question ou autre demande",
            en: "Service, question or other request",
            ru: "Обслуживание, вопрос или другой запрос",
            it: "Servizio, domanda o altra richiesta",
            es: "Servicio, pregunta u otra solicitud",
            pt: "Serviço, pergunta ou outro pedido",
            de: "Service, Frage oder andere Anfrage",
            ar: "خدمة أو سؤال أو طلب آخر",
        },
        titleVisible: true,
        descriptionVisible: true,
        active: true,
    },
];
